import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  Box,
  Typography,
  Grid,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import dayjs from "dayjs";

const Statements = ({ authCreate, authRead, authUpdate, authDelete }) => {
    const Navigate = useNavigate();
  const [dateRange, setDateRange] = useState("");
  const [customFrom, setCustomFrom] = useState("");
  const [customTo, setCustomTo] = useState("");

  const getDateRange = () => {
    const today = dayjs();
    switch (dateRange) {
      case "yesterday":
        return {
          from: today.subtract(1, "day").format("YYYY-MM-DD"),
          to: today.subtract(1, "day").format("YYYY-MM-DD"),
        };
      case "7_days":
        return {
          from: today.subtract(7, "day").format("YYYY-MM-DD"),
          to: today.format("YYYY-MM-DD"),
        };
      case "30_days":
        return {
          from: today.subtract(30, "day").format("YYYY-MM-DD"),
          to: today.format("YYYY-MM-DD"),
        };
      case "custom":
        return { from: customFrom, to: customTo };
      default:
        return {};
    }
  };

  const handleDownload = () => {
    const { from, to } = getDateRange();
    if (!from || !to) {
      alert("Please select a valid date range.");
      return;
    }

    // Replace with your actual download logic
    console.log("Downloading statements from", from, "to", to);
  };

  return (
    <Box>
      <Card elevation={4} sx={{ borderRadius: "16px", p: { xs: 2, md: 3 } }}>
        <CardContent>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              textAlign: "center",
              mb: 4,
              color: "#1976d2",
              letterSpacing: "1px",
            }}
          >
            MERCHANT STATEMENTS
          </Typography>

          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12}>
              <ToggleButtonGroup
                value={dateRange}
                exclusive
                onChange={(e, val) => {
                  if (val !== null) setDateRange(val);
                }}
                fullWidth
                color="primary"
              >
                <ToggleButton value="yesterday">Yesterday</ToggleButton>
                <ToggleButton value="7_days">Last 7 Days</ToggleButton>
                <ToggleButton value="30_days">Last 30 Days</ToggleButton>
                <ToggleButton value="custom">Custom</ToggleButton>
              </ToggleButtonGroup>
            </Grid>

            {dateRange === "custom" && (
              <>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    fullWidth
                    type="date"
                    label="From"
                    value={customFrom}
                    onChange={(e) => setCustomFrom(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    fullWidth
                    type="date"
                    label="To"
                    value={customTo}
                    onChange={(e) => setCustomTo(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} sm={6} md={2}>
              <Button
                fullWidth
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={() => {
                    const { from, to } = getDateRange();
                    if (!from || !to) {
                        alert("Please select a valid date range.");
                        return;
                    }

                    // Pass the filter and dates via URL
                    Navigate(`/DepositPortal/report-preview?filter=${dateRange}&from=${from}&to=${to}`);
                }}

                sx={{ height: "100%" }}
              >
                Download
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Statements;
